<template>
  <div class="financialForm">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="用户充值信息" name="first">

        <el-form ref="form" :model="form" :rules="rules" inline label-width="140px">
          <div class="tables">
            <table>
              <tr>
                <td>单号</td>
                <td>
                  <el-form-item prop="fBillNo">
                    <el-input v-model="form.fBillNo" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>制单时间</td>
                <td>
                  <el-form-item prop="fCreateTime">
                    <el-input v-model="form.fCreateTime" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>制单人</td>
                <td>
                  <el-form-item prop="fCreater">
                    <el-input v-model="form.fCreater" size="small" disabled />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>经销商名称</td>
                <td>
                  <el-form-item prop="fDistributorID">
                    <el-select
                      v-model="form.fDistributorID"
                      placeholder=""
                      size="small"
                      filterable
                      clearable
                      disabled
                      style="width:93%"
                      @change="selectDisChange"
                    >
                      <el-option
                        v-for="item in form.list"
                        :key="item.fid"
                        :label="item.fName"
                        :value="item.fid"
                      />
                    </el-select>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>转账金额</td>
                <td>
                  <el-form-item prop="fMoney_zz">
                    <el-input-currency v-model="form.fMoney_zz" :scale="2" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>代扣金额（借款）</td>
                <td>
                  <el-form-item prop="fMoney_jk">
                    <el-input-currency v-model="form.fMoney_jk" :scale="2" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td>充值账户</td>
                <td>
                  <el-form-item prop="fDistributorNumber">
                    <el-input v-model="form.fDistributorNumber" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>总充值金额</td>
                <td>
                  <el-form-item prop="total">
                    <el-input-currency v-model="form.total" :scale="2" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td>付款单位名称</td>
                <td>
                  <el-form-item prop="fPay">
                    <el-input v-model="form.fPay" disabled size="small" />
                  </el-form-item>
                </td>
              </tr>

              <tr>
                <td>意见</td>
                <td>
                  <el-form-item prop="fOpinion" style="width:100%">
                    <el-input
                      v-model="form.procedureInfo.fOpinion"
                      type="textarea"
                      :rows="3"
                      placeholder="填写意见内容"
                      :disabled="form.readOnly"
                    />
                  </el-form-item>
                </td>
              </tr>
            </table>
          </div>
        </el-form>

      </el-tab-pane>
      <el-tab-pane label="单据流程" name="second">
        <el-table
          :data="form.procedureMessage"
          class="tb-edit"
          style="width: 100%"
          highlight-current-row
        >
          <el-table-column label="单流程步骤" prop="fName" />
          <el-table-column label="处理人" prop="fUserName" />
          <el-table-column
            label="状态"
            prop="fState"
            width="75"
          />
          <el-table-column
            label="日期"
            prop="fDate"
            :formatter="dateFormat"
          />
          <el-table-column
            label="意见"
            prop="fOpinion"
          />
        </el-table>
      </el-tab-pane>

    </el-tabs>

    <div v-if="isDisplay" style="margin-top:20px;text-align:center">
      <el-button round type="success" size="small" :disabled="form.readOnly" :loading="Loading" @click="pass">通过</el-button>

      <el-button slot="reference" round type="primary" size="small" :disabled="form.readOnly" :loading="Loading" @click="back">回退</el-button>
    </div>

    <div v-else style="margin-top:20px;text-align:center">
      <el-button round type="success" size="small" :disabled="form.readOnly" :loading="Loading" @click="Really('form')">确认回退</el-button>
    </div>

    <el-dialog title="选择回退指定人员" :visible.sync="dialogBlocks" :modal="false" width="30%" :destroy-on-close="true">
      <el-form ref="form" :model="form.procedureInfo" :rules="rules">
        <el-form-item label="" prop="returnNode">
          <el-radio-group v-model="form.procedureInfo.returnNode">
            <el-radio v-for="v in listArr" :key="v.sqe" :label="v.sqe">{{ v.name }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      activeName: 'first',
      rules: {
        fDistributorID: [
          { required: true, message: '必填项', trigger: 'change' }
        ],

        fCreateTime: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        fCreater: [
          { required: true, message: '必填项', trigger: 'change' }
        ],

        fPay: [
          { required: true, message: '必填项', trigger: 'change' }
        ],
        returnNode: [
          { required: true, message: '必填项', trigger: 'change' }
        ]

      },
      dialogBlocks: false,
      listArr: null,
      isDisplay: true,
      Loading: false
    }
  },
  computed: {
  },
  watch: {
    'form.fMoney_jk': function(val, oldVal) {
      // console.log(val, 'val')
      this.form.total = Number(val + this.form.fMoney_zz)
    },
    'form.fMoney_zz': function(val, oldVal) {
      // console.log(val, 'val')
      this.form.total = Number(val + this.form.fMoney_jk)
    }
  },
  mounted: async function() {
    // console.log(this.form, 'this.form')
    const date = this.form.fCreateTime
    if (date == undefined || date == 'Invalid date' || date == '') {
      this.form.fCreateTime = ''
    } else {
      this.form.fCreateTime = moment(date).format('YYYY-MM-DD HH:mm:ss')
    }

    this.listArr = await this.$httpPost('RechargeManage/Recharge/GetHtProcedureEntry', { name: 'Recharge_cw_s' }).then((res) => res.datalist)
  },
  created() {},
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate((valid) => {
        if (valid) {
          onValid(this.form)
        } else {
          return false
        }
      })
    },
    selectDisChange(row) {
      // console.log(row, 'w')
      this.form.list.forEach(v => {
        if (row == v.fid) {
          this.form.fDistributorName = v.fName
          this.form.fDistributorNumber = v.fNumber
        }
      })
    },
    dateFormat: function(row, column, cellValue) {
      var date = cellValue
      if (date == undefined || date == 'Invalid date') {
        return ''
      }
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    handleClick() {

    },
    back() {
      this.dialogBlocks = true
      this.form.procedureInfo.fType = 2
    },
    confirm(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.dialogBlocks = false
          this.isDisplay = false
        } else {
          return false
        }
      })
    },
    Really(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.form.procedureInfo.fType = 2
          this.postData()
        } else {
          return false
        }
      })
    },
    pass() {
      this.form.procedureInfo.fType = 1
      this.postData()
    },
    postData() {
      this.Loading = true
      delete this.form.list
      return this.$httpPost(
        `RechargeManage/RechargeForCw/RechargeForCwApproval`,
        {
          datalist: JSON.stringify({ ...this.form })
        }
      ).then((res) => {
        if (res.isSuccess) {
          this.$message.success(res.message)
          this.$formDlgClose()
        } else {
          this.$message.error(res.message)
          throw res.message
        }
      })
        .finally(() => (this.Loading = false))
    }
  }
}
</script>

<style lang="less" >
.financialForm {
  .el-table td,
  .el-table th {
    padding: 5px 0;
  }
  .el-input.is-disabled .el-input__inner {
     background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #000;
    cursor: not-allowed;
}
.el-form-item {
     margin-bottom: 0px;
//     .el-form-item__error {
//     color: #F56C6C;
//     font-size: 12px;
//     line-height: 1;
//     padding-top: 4px;
//     position: absolute;
//     top: 23%;
//     left: 16px;
// }
}
.el-form--inline .el-form-item__content {
    width: 100%;
}
.tables{
  border-collapse:collapse;
table{
  border-collapse:collapse;
        border-bottom:1px solid rgb(158, 158, 158);
      width:100%;
   tr{
      display: flex;
      border-bottom: none;
    }
    td{
      flex:3;
            border:1px solid rgb(158, 158, 158);
            border-bottom: none;
   }
    td:nth-child(1){
       border-right:none;
     flex:1;
     text-indent: 40px;
     line-height: 40px;
    }
}
}

}
</style>
